import { m, useReducedMotion } from 'motion/react';

const DIGITS = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
const spring = { type: 'spring' as const, stiffness: 320, damping: 32, mass: 0.9 };

/**
 * Big number with odometer roll (DESIGN §2.2): each digit is a 0–9 strip that slides to
 * its value. Columns are keyed from the right so 9 → 10 adds a digit instead of reshuffling.
 */
export function Odometer({
  value,
  format = (n) => String(n),
  className,
  label,
}: {
  value: number;
  /** Accessible label (defaults to the formatted value). */
  label?: string;
  format?: (n: number) => string;
  className?: string;
}) {
  const reduce = useReducedMotion();
  const chars = format(value).split('');
  return (
    <span
      className={`tabular inline-flex leading-none ${className ?? ''}`}
      aria-label={label ?? format(value)}
      role="text"
    >
      {chars.map((ch, i) => {
        const key = chars.length - i;
        if (!/\d/.test(ch)) {
          return (
            <span key={`s${key}`} aria-hidden>
              {ch}
            </span>
          );
        }
        return (
          <span key={key} aria-hidden className="relative inline-block h-[1em] overflow-hidden">
            <m.span
              className="flex flex-col"
              initial={false}
              animate={{ y: `${-Number(ch)}em` }}
              transition={reduce ? { duration: 0 } : spring}
            >
              {DIGITS.map((d) => (
                <span key={d} className="h-[1em]">
                  {d}
                </span>
              ))}
            </m.span>
          </span>
        );
      })}
    </span>
  );
}
